import ArticlePage from '@/pages/article/ArticlePage.vue';
import ArticlesSights from '@/pages/articlesSights/ArticlesSights.vue';
import AuthorPage from '@/pages/author/AuthorPage.vue';
import CityArticlesPage from '@/pages/cityArticles/CityArticlesPage.vue';
import CountryArticlesPage from '@/pages/countryArticles/CountryArticlesPage.vue';
import JournalPage from '@/pages/journal/JournalPage.vue';
import RegionArticlesPage from '@/pages/regionArticles/RegionArticlesPage.vue';
import UGC from '@/pages/UGC/index.vue';
// import ArticleOrSight from '@/pages/articleOrSight/index.vue';

const initRoutes = () => {
  const routes = [
    {
      name: 'journal',
      path: `/`,
      component: JournalPage,
    },
    {
      name: 'journal-author',
      path: '/author/:id',
      component: AuthorPage,
    },
    {
      name: 'journal-city-articles',
      path: '/city/articles/:slug',
      component: CityArticlesPage,
    },
    {
      name: 'journal-country-articles',
      path: '/country/articles/:slug',
      component: CountryArticlesPage,
    },
    {
      name: 'journal-region-articles',
      path: '/region/articles/:slug',
      component: RegionArticlesPage,
    },
    {
      name: 'journal-articles-sights',
      path: '/articles/sights/:slug',
      component: ArticlesSights,
    },
    {
      name: 'journal-UGC',
      path: '/ugc',
      component: UGC,
    },
    // {
    //   name: 'journal-article-or-sight',
    //   path: '/articles/:slug',
    //   alias: '/sights/:slug',
    //   component: ArticleOrSight,
    // },
  ];

  routes.push({
    name: 'journal-article',
    path: '/articles-new/:slug',
    component: ArticlePage,
  });

  return routes;
};

export const defaultRoutes = initRoutes();
